// extracted by mini-css-extract-plugin
export default {"container":"LK-z","topReviewHeading":"MK-z","criticalReview":"NK-z","favorableReview":"OK-z","vsSeparator":"PK-z"};